import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import StatusPill from 'features/IRWorkstation/components/StatusPill';

const QuadPanel = ({ title, badge, badgeColor, subtitle, tryIt, children }) => {
	return (
		<Box
			sx={{
				backgroundColor: 'background.paper',
				border: '0.5px solid',
				borderColor: 'border.light',
				borderRadius: '12px',
				display: 'flex',
				flexDirection: 'column',
				overflow: 'hidden',
				minHeight: 0,
			}}
		>
			{/* header */}
			<Box
				sx={{
					padding: '12px 15px 10px',
					borderBottom: '0.5px solid',
					borderColor: 'border.light',
					flexShrink: 0,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						mb: '3px',
					}}
				>
					<Typography
						sx={{ fontSize: '13px', fontWeight: 600, color: 'text.primary' }}
					>
						{title}
					</Typography>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
						{tryIt && (
							<Box
								sx={{
									fontSize: '10px',
									fontWeight: 600,
									color: 'status.blue.text',
									backgroundColor: 'status.blue.bg',
									padding: '2px 6px',
									borderRadius: '3px',
									cursor: 'pointer',
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									opacity: 1,
									transition: 'opacity 0.2s',
									animation: 'tryItPulse 2s ease-in-out infinite',
									'@keyframes tryItPulse': {
										'0%, 100%': { opacity: 1 },
										'50%': { opacity: 0.55 },
									},
									'&:hover': {
										animation: 'none',
										opacity: 1,
									},
								}}
							>
								<Box component='span' sx={{ mr: '3px' }}>
									▶
								</Box>
								<Box component='span'>Try it</Box>
							</Box>
						)}
						{badge && (
							<StatusPill
								label={badge}
								color={badgeColor}
								sx={{
									fontSize: '11px',
									fontWeight: 500,
									padding: '3px 9px',
									borderRadius: '20px',
								}}
							/>
						)}
					</Box>
				</Box>
				{subtitle && (
					<Box sx={{ fontSize: '11px', color: 'text.secondary' }}>
						{subtitle}
					</Box>
				)}
			</Box>

			{/* scrollable body */}
			<Box
				sx={{
					flex: 1,
					overflowY: 'auto',
				}}
			>
				{children}
			</Box>
		</Box>
	);
};

QuadPanel.propTypes = {
	title: PropTypes.string.isRequired,
	badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	badgeColor: PropTypes.string,
	subtitle: PropTypes.node,
	tryIt: PropTypes.bool,
	children: PropTypes.node,
};

export default QuadPanel;
